export const USER_ROLES = {
  ADMIN: 'admin',
  OPERATION: 'operation',
  MARKETING: 'marketing',
};

export const ROLE_LABELS = {
  [USER_ROLES.ADMIN]: 'Administrator',
  [USER_ROLES.OPERATION]: 'Operations Manager',
  [USER_ROLES.MARKETING]: 'Marketing Manager',
};

export const ROLE_DESCRIPTIONS = {
  [USER_ROLES.ADMIN]: 'Full system access with all administrative privileges',
  [USER_ROLES.OPERATION]:
    'Operational management with content and user oversight',
  [USER_ROLES.MARKETING]:
    'Marketing focused access with campaign and analytics tools',
};

export const ROLE_PERMISSIONS = {
  [USER_ROLES.ADMIN]: [
    'users.create',
    'users.read',
    'users.update',
    'users.delete',
    'content.create',
    'content.read',
    'content.update',
    'content.delete',
    'settings.read',
    'settings.update',
    'analytics.read',
    'audit.read',
    'system.admin',
  ],
  [USER_ROLES.OPERATION]: [
    'users.read',
    'users.update',
    'content.create',
    'content.read',
    'content.update',
    'content.delete',
    'analytics.read',
    'notifications.manage',
  ],
  [USER_ROLES.MARKETING]: [
    'content.create',
    'content.read',
    'content.update',
    'analytics.read',
    'campaigns.manage',
    'social.manage',
  ],
};

export const ROLE_HIERARCHY = {
  [USER_ROLES.ADMIN]: 3,
  [USER_ROLES.OPERATION]: 2,
  [USER_ROLES.MARKETING]: 1,
};
